<!-- TODO NEED OPTIMIZATION -->
<template>
  <div class="container-fluid full-height-page-wrapper">
    <div class="row">
      <b-modal size="lg" hide-footer ref="bookingModal" centered  :modal-class="isModalLoading ? 'loading' : ''">
        <template v-slot:modal-header="{ cancel }">
          <h5 class="modal-title">{{ !!editedItem.id ? 'Edit booking' : 'Create booking' }}</h5>
          <button type="button" aria-label="Close" class="close" @click.prevent="cancel">
            <span class="material-icons">
              close
            </span>
          </button>
        </template>
        <BookingForm v-if="dialog" :projects="projects" :users="users" :unitManagers="unitManagers"
          :dataProps="editedItem" :edit="!!editedItem.id" :modal="true" :show-preloader="true"
          :isModalLoading="isModalLoading" @submit="submit" @remove="onRemove" />
      </b-modal>
      <div class="col-12">
        <div class="page-table-header">

          <PageHeader page-title="Booking table" showBreadcrumbs>
            <template #buttons>
              <b-button class="button title-container__controls-item" :variant="isShowFilter ? 'secondary' : 'info'"
                @click="toggleShowFilter">
                <span class="material-icons icon-image-preview">
                  tune
                </span>
                Filters
              </b-button>
              <b-button v-if="$can('create-booking_management')" variant="success" class="button"
                @click="bookingModalOpen()" :disabled="loading">
                Create
              </b-button>
            </template>
          </PageHeader>

          <Filters v-if="$can('read_all-booking_management')" v-show="isShowFilter" textButtonSubmit="Filter"
            :data="filters" :isLoading="loading && isInitialDataLoaded" @submit="getBookingByFilter" />

          <div v-if="loading && !isInitialDataLoaded" class="content-loading-wrapper">
            <Preloader class="centered-preloader" />
          </div>

          <div v-else>
            <TableForPage ref="table" style="margin-bottom: 0;" v-if="table.data.length" :isDataLoading="loading && isInitialDataLoaded"
            :tableData="table.data" :fields="table.fields" :slots="table.slots"
            :isEdit="$can('update_all-booking_management')" :isRemove="$can('delete-booking_management')"
            @edit="bookingModalOpen" @remove="deleteBooking" @update="updateTable">
            <template v-slot:user_id="slotProps">
              <TableUserItem :user='__getUser(slotProps.item.user_id)' :number="getNumber(slotProps.index)" />
            </template>
            <template v-slot:project_id="slotProps">
              <span>{{ __getProjectName(slotProps.item.project_id) }}</span>
            </template>
            <template v-slot:hours_per_day="slotProps">
              <span>{{ slotProps.item.hours_per_day || '-' }}</span>
            </template>
            <template v-slot:booking_hours="slotProps">
              <span>{{ slotProps.item.booking_hours || '-' }}</span>
            </template>
          </TableForPage>
          <EmptyStateNoResults
            v-else-if="isInitialDataLoaded && !table.data.length"
            title="No bookings yet"
            description="You haven't created any bookings yet. Start by adding one to track time allocations."
            customIcon="schedule"
            customIconClasses="material-symbols-outlined empty-state__icon"
            buttonText="CREATE BOOKING"
            @button-click="handleCreateClick"
          />
          </div>
          <error-modal ref="errorModal" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import BookingForm from '../components/forms/BookingForm'
import BookingMixin from '../mixins/booking'
import { mapGetters } from 'vuex'
import Filters from '@components/Filter/Filter'
import TableForPage from '@tables/TableForPage'
import TableUserItem from '@components/tables/TableUserItem'
import PageHeader from '@components/PageHeader.vue'
import Preloader from '@components/Preloader'
import EmptyStateNoResults from '@components/EmptyStateNoResults'

export default {
  name: 'BookingManagment',
  data () {
    return {
      loading: true,
      isModalLoading: false,
      isShowFilter: true,
      isAllOptionsFilterSet: false,
      isBookingDataLoaded: false,
      currentPage: 1,
      perPage: 15,
      filters: {
        'projects': {
          type: 'multiselect',
          name: 'projectIds',
          label: 'Select projects',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        'users': {
          type: 'multiselect',
          name: 'users',
          label: 'Select users',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        },
        'unitManagers': {
          type: 'multiselect',
          name: 'unitManagerIds',
          label: 'Select unit managers',
          valueField: 'id',
          selectLabel: 'name',
          options: [],
          value: [],
          class: 'col-md-3'
        }
      },
      selectedFilters: {},
      firstLoad: false,
      dialog: false,
      defaultFormData: {},
      editedItem: {
        start_date: ''
      },
      table: {
        fields: [
          {
            key: 'user_id',
            label: 'User',
            class: 'column-long-name'
          },
          {
            key: 'project_id',
            label: 'Project'
          },

          {
            key: 'start_date',
            label: 'Start date'
          },
          {
            key: 'end_date',
            label: 'End date'
          },
          {
            key: 'hours_per_day',
            label: 'Hours per day'
          },
          {
            key: 'booking_hours',
            label: 'Booking hours'
          },
          {
            key: 'comment',
            label: 'Comment'
          },
          {
            key: 'updated_at',
            label: 'Last update'
          },
          {
            key: 'actions',
            label: 'Actions',
            class: 'column_action'
          }
        ],
        data: [],
        slots: {
          project_id: {
            name: 'project_id'
          },
          user_id: {
            name: 'user_id'
          },
          hours_per_day: {
            name: 'hours_per_day'
          },
          booking_hours: {
            name: 'booking_hours'
          }
        }
      },
      users: [],
      projects: []
    }
  },
  components: {
    BookingForm,
    Filters,
    TableForPage,
    TableUserItem,
    PageHeader,
    Preloader,
    EmptyStateNoResults
  },
  mixins: [BookingMixin],
  created () {
    (async () => {
      if (this.$can('read_own-booking_management') && !this.$can('read_all-booking_management')) {
        this.filter.users.push(this._UserInfo)
        this.users.push(this._UserInfo)
      }
      await this.axios
        .get('/api/projects', {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(response => {
          if (response.status === 200) {
            this.filters.projects.options = response.data
            this.projects = response.data
          }
        })
        .catch(console.error)
      await this.axios
        .post(
          '/api/users',
          {},
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.filters.users.options = response.data
            this.users = response.data
          }
        })
        .catch(console.error)
      await this.axios
        .post(
          '/api/get-unit-managers',
          {
            unit_managers: []
          },
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .then(response => {
          if (response.status === 200) {
            this.filters.unitManagers.options = response.data
            if (Object.keys(this.$route.query).length !== 0) {
              for (let item in this.$route.query) {
                if (item.indexOf('users') !== -1) {
                  this.users.forEach((element, index) => {
                    if (element.id === +this.$route.query[item]) {
                      this.filters.users.value.push(element)
                      this.users.push(element)
                    }
                  })
                } else if (item.indexOf('unitManagers') !== -1) {
                  this.unitManagers.forEach((element, index) => {
                    if (element.id === +this.$route.query[item]) {
                      this.filters.unitManagers.value.push(element)
                    }
                  })
                } else if (item.indexOf('projects') !== -1) {
                  this.projects.forEach((element, index) => {
                    if (element.id === +this.$route.query[item]) {
                      this.filters.projects.value.push(element)
                      this.projects.push(element)
                    }
                  })
                }
              }
            }
          }
        })
        .catch(console.error)
      this.isAllOptionsFilterSet = true
      await this.getBooking()
    })()
  },
  computed: {
    isInitialDataLoaded () {
      return this.isAllOptionsFilterSet && this.isBookingDataLoaded
    },
    ...mapGetters({
      dateFormat: 'dateFormat',
      getCurrentUserRole: 'getCurrentUserRole',
      getCurrentUserName: 'getCurrentUserName'
    })
  },
  methods: {
    async onRemove (item) {
      const { id } = item
      this.$refs['bookingModal'].hide()
      this.dialog = false

      this.axios
        .post(
          '/api/booking/delete/' + id,
          {},
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .then(() => {
          this.successNotifications('Booking deleted successfully')
        })
        .catch(err => {
          this.errorNotifications(err)
        })
        .finally(() => {
          this.editedItem = {}
          this.getBooking()
        })
    },
    toggleShowFilter () {
      this.isShowFilter = !this.isShowFilter
    },
    prepareDataForGetReports (fields) {
      let data = {}

      for (let key in fields) {
        const name = fields[key]['name']
        let value = fields[key]['value']

        if (Array.isArray(value)) {
          value = value.map(item => item[fields[key]['valueField']])
        }

        data[name] = value
      }

      return data
    },
    resetPagination () {
      this.$refs['table'] && this.$refs['table'].resetPagination()
    },
    async getBookingByFilter (fields) {
      this.selectedFilters = fields
      this._setRouteByFields(fields)
      await this.getBooking()
    },
    createHtmlCodeForMessages (messages) {
      let htmlData = null
      if (messages.length) {
        htmlData = '<div>'
        messages.forEach(msg => {
          htmlData += `<p>${msg}</p>`
        })
        htmlData += '</div>'
      }
      return htmlData
    },
    getBooking () {
      const data = this.prepareDataForGetReports(this.selectedFilters)

      this.loading = true
      return this.axios
        .post('/api/bookings', data, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(response => {
          this.table.data = response.data
          this.isBookingDataLoaded = true
        })
        .catch(err => {
          this.errorNotifications(err)
        })
        .finally(() => {
          this.loading = false
          this.firstLoad = true
        })
    },
    create (data) {
      this.isModalLoading = true
      this.axios
        .post('/api/booking/create', data, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then((response) => {
          this.successNotifications('Booking created successfully', this.createHtmlCodeForMessages(response.data.messages))
          this.$refs['bookingModal'].hide()
          this.dialog = false
          this.getBooking()
          this.editedItem = {}
        })
        .catch(err => {
          this.errorNotifications(err)
        })
        .finally(() => {
          this.isModalLoading = false
        })
    },
    bookingModalOpen (data = {}) {
      this.editedItem = Object.assign({}, data)
      this.dialog = true
      this.$refs['bookingModal'].show()
    },
    edit (data) {
      this.isModalLoading = true
      this.axios
        .post('/api/booking/update/' + this.editedItem.id, data, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then((response) => {
          this.$refs['bookingModal'].hide()
          this.successNotifications('Booking edited successfully', this.createHtmlCodeForMessages(response.data.messages))
          this.dialog = false
          this.getBooking()
          this.editedItem = {}
        })
        .catch(err => {
          this.errorNotifications(err)
        })
        .finally(() => {
          this.isModalLoading = false
        })
    },
    submit (data) {
      if (this.editedItem.id) {
        this.edit(data)
      } else {
        this.create(data)
      }
    },
    async deleteBooking (item) {
      const { id } = item

      const confirm = await this.$root.$confirm.open(
        'Delete',
        'Are you sure you want to delete?'
      )

      if (!confirm) {
        return
      }

      this.axios
        .post(
          '/api/booking/delete/' + id,
          {},
          {
            headers: {
              Authorization: 'Bearer' + localStorage.getItem('access_token')
            }
          }
        )
        .then(() => {
          this.successNotifications('Booking deleted successfully')
        })
        .catch(err => {
          this.errorNotifications(err)
        })
        .finally(() => {
          this.getBooking()
        })
    },
    updateTable (data) {
      this.currentPage = data.currentPage
      this.perPage = data.perPage
    },
    getNumber (index) {
      if (this.currentPage > 1) {
        const curPage = this.currentPage - 1
        return (this.perPage * curPage) + index
      } else {
        return index
      }
    },
    handleCreateClick () {
      this.bookingModalOpen()
    }
  },
  updated () {}
}
</script>

<style scoped lang="scss">
.table-wrapper {
  padding-top: 20px;
}
.table-wrapper h3 {
  margin-bottom: 30px;
}
.booking-table {
  background-color: #fff;
}
.booking-table-wrapper {
  max-height: 600px;
  overflow-y: auto;
}
.spinner-border {
  border-width: 0.25rem !important;
}
.filter-buttons {
  padding-top: 34px;
}
</style>
